import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { useLocation } from 'react-router-dom';

const Payment = () => {
  const baseURL = process.env.REACT_APP_BASE_URL_API;
  const redirectURL = process.env.REACT_APP_BASE_REDIRECT_URL;
  const { search } = useLocation();
  let orderId = '';
  const userId = new URLSearchParams(search).get('user-id');
  const raceId = new URLSearchParams(search).get('race-id');
  const eventId = new URLSearchParams(search).get('event-id');
  const participantId = new URLSearchParams(search).get('participant-id');
  const groupRegistrationId = new URLSearchParams(search).get(
    'group-registration-id',
  );
  let groupRegistration = new URLSearchParams(search).get('group-registration');
  const donationAmount = +new URLSearchParams(search).get('donation-amount');

  if (groupRegistration === 'true') {
    groupRegistration = true;
  } else {
    groupRegistration = false;
  }

  const initialOptions = {
    'client-id': process.env.REACT_APP_VENMO_KEY,
    'enable-funding': 'venmo',
    'disable-funding': 'card,credit,paylater',
    currency: 'USD',
    commit: 'true',
  };

  const payload = {
    raceId,
    eventId,
    participantId,
    groupRegistration,
    donationAmount,
  };

  const payloadCreateOrder = {
    ...payload,
    userId,
    groupRegistrationId,
  };
  const payloadOnApprove = {
    ...payload,
    userId,
    groupRegistrationId,
  };

  if (participantId) {
    delete payloadCreateOrder.groupRegistrationId;
    delete payloadCreateOrder.groupRegistration;
    delete payloadOnApprove.groupRegistrationId;
    delete payloadOnApprove.groupRegistration;
  } else {
    delete payloadCreateOrder.participantId;
    delete payloadOnApprove.participantId;
  }

  if (!userId) {
    delete payloadCreateOrder.userId;
    delete payloadOnApprove.userId;
  }

  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          createOrder={() => {
            const apiUrl = `${baseURL}/create-paypal-race-payment-order`;
            return fetch(apiUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payloadCreateOrder),
            })
              .then((response) => response.json())
              .then((data) => {
                orderId = data.data.id;
                return data.data.id;
              });
          }}
          onApprove={() => {
            const apiUrl = `${baseURL}/capture-payment`;
            return fetch(apiUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...payloadOnApprove, orderId }),
            })
              .then((response) => response.json())
              .then((data) => {
                let url = '';
                if (data.statusCode === 441) {
                  url = `${redirectURL}/#/success?event-id=${new URLSearchParams(
                    search,
                  ).get('event-id')}&race-director=${new URLSearchParams(
                    search,
                  ).get('race-director')}&qr-code=${new URLSearchParams(
                    search,
                  ).get('qr-code')}`;
                  window.location.replace(url);
                } else if (data.statusCode === 442) {
                  url = `${redirectURL}/#/failure?event-id=${new URLSearchParams(
                    search,
                  ).get('event-id')}&race-director=${new URLSearchParams(
                    search,
                  ).get('race-director')}&qr-code=${new URLSearchParams(
                    search,
                  ).get('qr-code')}`;
                  window.location.replace(url);
                }
                return data;
              })
              .catch(() => {
                let url = '';
                url = `${redirectURL}/#/failure?event-id=${new URLSearchParams(
                  search,
                ).get('event-id')}&race-director=${new URLSearchParams(
                  search,
                ).get('race-director')}&qr-code=${new URLSearchParams(
                  search,
                ).get('qr-code')}`;
                window.location.replace(url);
              });
          }}
        />
      </PayPalScriptProvider>
    </div>
  );
};

export default Payment;
